import {
  GL_BAR_CHART,
  GL_SETTINGS,
  GL_SHARE,
  GL_USERS_THREE,
  GLAsideItemProps,
  useGLMenuMobile,
  useI18n,
} from '@group-link-one/grouplink-components';
import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { usePrivileges } from '../../hooks/usePrivilleges';
import { useAuth, useGLFlags } from '@group-link-one/gl-utils';
import { verifyIfPathIsActive } from '@/utils/verifyIfPathIsActive';

export enum MainRoutes {
  SETTINGS = '/settings',
  REPORTS = '/reports',
  EVENT_LIST = '/network/event-list',
  USER_EVENTS = '/user-events',
}

interface MainLayout {
  navListTop: GLAsideItemProps[];
  navListBottom: GLAsideItemProps[];
}

export const useMainLayout = (): MainLayout => {
  const { t } = useI18n();
  const navigate = useNavigate();
  const { handleOpenMenuMobile, isMenuMobileOpen } = useGLMenuMobile();
  const { flags } = useGLFlags();
  const { pages } = usePrivileges();
  const { user } = useAuth();

  const navListTop: GLAsideItemProps[] = useMemo(() => {
    const allPages: GLAsideItemProps[] = [
      // Reports Page
      {
        id: 1,
        Icon: GL_BAR_CHART,
        text: t('pages.reports.title'),
        isToAppear: pages.reports,
        active: verifyIfPathIsActive(MainRoutes.REPORTS),
        dropdownItems: [],
        onClick: () => {
          navigate(MainRoutes.REPORTS);
        },
      },
      // Event List Page
      {
        id: 2,
        Icon: GL_SHARE,
        text: t('eventList.subtitle'),
        isToAppear: pages.eventList,
        active: verifyIfPathIsActive(MainRoutes.EVENT_LIST, false),
        dropdownItems: [],
        onClick: () => navigate(MainRoutes.EVENT_LIST),
      },
      // User Events Page
      {
        id: 3,
        Icon: GL_USERS_THREE,
        text: t('userEvents.title'),
        isToAppear: pages.userEvents,
        active: verifyIfPathIsActive(MainRoutes.USER_EVENTS, false),
        dropdownItems: [],
        onClick: () => navigate(MainRoutes.USER_EVENTS),
      },
    ];

    return allPages
      .filter((item) => {
        if (item.isToAppear) {
          return item;
        }
      })
      .map((item) => {
        if (item.dropdownItems?.length) {
          const newItem = {
            ...item,
            dropdownItems: item.dropdownItems.filter((dropdownItem) => {
              if (dropdownItem.isToAppear) {
                return dropdownItem;
              }
            }),
          };

          return newItem;
        }

        return item;
      });
  }, [
    flags, // para quando as flags carregarem
    user, // para quando realizar o impersonate
    pages, // ao realizar impersonate, os privilégios mudam
  ]);

  const navListBottom: GLAsideItemProps[] = [
    {
      id: 1,
      Icon: GL_SETTINGS,
      text: t('pages.settings.title'),
      active: verifyIfPathIsActive(MainRoutes.SETTINGS, false),
      onClick: () => {
        navigate(MainRoutes.SETTINGS);
      },
    },
  ];

  const removeStyle = (): void => {
    const container = document.querySelector('.page-animated');
    if (container) {
      container.removeAttribute('style');
    }
  };

  useEffect(() => {
    if (isMenuMobileOpen) {
      handleOpenMenuMobile();
    }

    removeStyle();
  }, [navigate]);

  return { navListTop, navListBottom };
};
